module.exports = __webpack_public_path__ + "static/img/banner-fixed.e8ee27f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-fixed.jpg
// module id = 2J8/
// module chunks = 1